<script setup lang="ts">
import {
  AccordionRoot,
  type AccordionRootEmits,
  type AccordionRootProps,
  useEmitAsProps,
} from 'radix-vue'

const props = defineProps<AccordionRootProps>()
const emits = defineEmits<AccordionRootEmits>()
</script>

<template>
  <AccordionRoot class="c-accordion border-none" v-bind="{ ...props, ...useEmitAsProps(emits) }">
    <slot />
  </AccordionRoot>
</template>

<style scoped>
.c-accordion {
  --c-accordion-vertical-padding: theme("padding.12");
  --c-accordion-vertical-gap: theme("padding.8");

  @screen tablet-wide {
    --c-accordion-vertical-padding: theme("padding.16");
    --c-accordion-vertical-gap: theme("padding.12");
  }
}
</style>
